import React from 'react';
import propTypes from 'prop-types';
;
import { Button, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FadeInDiv, AnimatedCard } from '../logic';
import { usePoseWithBulma } from '../hooks';

export function ConfirmDeletionModal({
  title,
  isActive,
  onClickCancel,
  onClickConfirm,
}) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );

  return (
    <Modal isActive={isModalVisible} className="confirm-deletion-modal">
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        <ModalCardHeader>
          <ModalCardTitle
            tag="h6"
            hasTextAlign="centered"
            className="has-text-weight-semibold"
          >
            Confirm Archiving
          </ModalCardTitle>
        </ModalCardHeader>
        <ModalCardBody hasTextAlign="centered">
          <span className="icon is-large has-icon-gradient-warning">
            <FontAwesomeIcon
              icon={['fal', 'exclamation-circle']}
              className="is-size-2"
            />
          </span>
          <p className="has-text-grey-medium-dark">
            Are you sure you want to archive
            <b className="is-size-5 has-text-weight-semibold has-text-info is-block">
              {title}
            </b>
          </p>
          <div className="buttons is-centered">
            <Button
              isColor="gradient-warning"
              className="is-long"
              onClick={onClickConfirm}
            >
              Archive
            </Button>
            <Button
              isOutlined
              className="is-long"
              hasTextColor="info"
              onClick={onClickCancel}
            >
              Cancel
            </Button>
          </div>
        </ModalCardBody>
      </ModalCard>
    </Modal>
  );
}

ConfirmDeletionModal.defaultProps = {
  onClickCancel: () => {},
  onClickConfirm: () => {},
};

ConfirmDeletionModal.propTypes = {
  title: propTypes.string.isRequired,
  isActive: propTypes.bool.isRequired,
  onClickCancel: propTypes.func,
  onClickConfirm: propTypes.func,
};
